module.exports = __webpack_public_path__ + "static/media/044.b80eb657.jpg";